import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { MobileNav } from "./components/MobileNav";
import { DevAdBadge } from "./components/DevAd";
import { HomePage } from "./pages/HomePage";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { ResourcesPage } from "./pages/ResourcesPage";
import { VacanciesPage } from "./pages/VacanciesPage";
import { ContactPage } from "./pages/ContactPage";
import { AdvertisePage } from "./pages/AdvertisePage";
import { MemberDashboard } from "./pages/MemberDashboard";
import { AdminDashboard } from "./pages/AdminDashboard";
import Advertisements from "./pages/Advertisements"; // ✅ NEW IMPORT
import "./App.css";

// Layout wrapper for pages with header/footer
const MainLayout = ({ children, showFooter = true }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      {showFooter && <Footer />}
      <MobileNav />
      <DevAdBadge />
    </div>
  );
};

// Auth layout (no header/footer)
const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen">
      {children}
      <DevAdBadge />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster 
          position="top-center" 
          richColors 
          toastOptions={{
            style: {
              background: 'rgba(18, 18, 18, 0.9)',
              backdropFilter: 'blur(12px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              color: '#fff',
            },
          }}
        />
        <Routes>
          {/* Public Pages */}
          <Route
            path="/"
            element={
              <MainLayout>
                <HomePage />
              </MainLayout>
            }
          />
          <Route
            path="/resources"
            element={
              <MainLayout>
                <ResourcesPage />
              </MainLayout>
            }
          />
          <Route
            path="/vacancies"
            element={
              <MainLayout>
                <VacanciesPage />
              </MainLayout>
            }
          />
          <Route
            path="/contact"
            element={
              <MainLayout showFooter={false}>
                <ContactPage />
              </MainLayout>
            }
          />
          <Route
            path="/advertise"
            element={
              <MainLayout>
                <AdvertisePage />
              </MainLayout>
            }
          />
          
          {/* ✅ NEW ROUTE - Advertisements Display Page */}
          <Route
            path="/advertisements"
            element={
              <MainLayout>
                <Advertisements />
              </MainLayout>
            }
          />

          {/* Auth Pages */}
          <Route
            path="/login"
            element={
              <AuthLayout>
                <LoginPage />
              </AuthLayout>
            }
          />
          <Route
            path="/register"
            element={
              <AuthLayout>
                <RegisterPage />
              </AuthLayout>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <AuthLayout>
                <ForgotPasswordPage />
              </AuthLayout>
            }
          />

          {/* Protected Member Pages */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <MainLayout showFooter={false}>
                  <MemberDashboard />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          {/* Protected Admin Pages */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly>
                <MainLayout showFooter={false}>
                  <AdminDashboard />
                </MainLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
